import { createSelector } from 'reselect'
import { RootState } from 'store/rootReducer'

const importLogSelector = (s: RootState) => s.importLogs

export const getImportLogs = createSelector(
  importLogSelector,
  s => s.importLogs,
)
